import {
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CheckIcon from "@mui/icons-material/Check";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

const CoreRadioChangeRole = (props) => {
  const {
    className,
    name,
    legendLabel,
    options,
    labelInValue,
    classNameRadioGroup,
    classNameRadio,
    row,
    required,
    helperText,
    disabled,
    iconChecked,
    classNameLabel,
    ...restProps
  } = props;
  const { control } = useFormContext();
  const { t } = useTranslation("common");
  return (
    <div className={className}>
      <Controller
        control={control}
        name={name}
        rules={{
          required: required
            ? t("message.emptyField", { field: legendLabel })
            : false,
        }}
        render={({
          field: { onChange, value, ref },
          fieldState: { error },
        }) => {
          return (
            <>
              {legendLabel && (
                <FormLabel
                  component="legend"
                  required={required}
                  error={!!error}
                  className={classNameLabel}
                >
                  {legendLabel}
                </FormLabel>
              )}
              <RadioGroup
                row={row}
                name={name}
                onChange={onChange}
                value={value ?? null}
                className={classNameRadioGroup}
                ref={ref}
                {...restProps}
              >
                <div className={`flex flex-col`}>
                  {options?.map((item) => {
                    const isChecked = value === item.value;
                    return (
                      <FormControlLabel
                        key={item.value}
                        value={labelInValue ? JSON.stringify(item) : item.value}
                        control={
                          <Radio
                            checkedIcon={<CheckIcon sx={{ color: "white" }} />}
                            icon={
                              <CheckBoxOutlineBlankIcon
                                sx={{ visibility: "hidden" }}
                              />
                            }
                            color="primary"
                            size="small"
                          />
                        }
                        className={classNameRadio}
                        label={
                          <span
                            className={`px-10 ${isChecked ? "text-white" : ""}`}
                          >
                            {item.label}
                          </span>
                        }
                        disabled={Boolean(item?.disabled) || disabled}
                        sx={{
                          margin: 0,
                          backgroundColor: isChecked ? "#F89E19" : "",
                        }}
                      />
                    );
                  })}
                </div>
              </RadioGroup>
              {error && error.message && (
                <FormHelperText error={!!error}>{error.message}</FormHelperText>
              )}
              {helperText && <FormHelperText>{helperText}</FormHelperText>}
            </>
          );
        }}
      />
    </div>
  );
};

CoreRadioChangeRole.defaultProps = {
  className: null,
  legendLabel: null,
  row: false,
  labelInValue: false,
};

CoreRadioChangeRole.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  classNameRadioGroup: PropTypes.string,
  name: PropTypes.string.isRequired,
  legendLabel: PropTypes.string,
  row: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
      label: PropTypes.any.isRequired,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  labelInValue: PropTypes.bool,
  required: PropTypes.bool,
  helperText: PropTypes.any,
  gridItem: PropTypes.bool,
  iconChecked: PropTypes.any,
  classNameLabel: PropTypes.string,
};

export default React.memo(CoreRadioChangeRole);
